import { FormControl } from '@angular/forms';

export class ValidatorsService {
  static vatValidator(control: FormControl) {
    // RFC 2822 compliant regex
    if (control.value) {
      if (control.value.match(/^(.{0}|\d{11})$/)) {
        return null;
      } else {
        return { invalidVat: true };
      }
    }
  }

  static fiscalCodeValidator(control) {
    // RFC 2822 compliant regex
    if (control.value) {
      if (control.value.match(/(^$|[A-Za-z0-9]{12,13}$)/)) {
        return null;
      } else {
        return { invalidFiscalCode: true };
      }
    }
  }

  static cuuaValidator(control) {
    if (control.value) {
      // RFC 2822 compliant regex
      if (control.value.match(/(^$|[A-Za-z0-9]{11,12}$)/)) {
        return null;
      } else {
        return { invalidCuua: true };
      }
    }
  }

  static zipCodeValidator(control) {
    // RFC 2822 compliant regex
    if (control.value) {
      if (control.value.match(/^(.{0}|\d{5})$/)) {
        return null;
      } else {
        return { invalidZipCode: true };
      }
    }
  }
}
